"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenceTypes = void 0;
var PresenceTypes;
(function (PresenceTypes) {
    PresenceTypes["ALL"] = "ALL";
    PresenceTypes["ARRIVAL"] = "ARRIVAL";
    PresenceTypes["DEPARTURE"] = "DEPARTURE";
})(PresenceTypes = exports.PresenceTypes || (exports.PresenceTypes = {}));
//# sourceMappingURL=PresenceTypes.js.map